"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePM = void 0;
const utils_1 = require("./utils");
const extendedTableShock_1 = require("./extendedTableShock");
const liquidityShock_1 = require("./liquidityShock");
const marketShift_1 = require("./marketShift");
const utils_2 = require("./utils");
const vegaShock_1 = require("./vegaShock");
const volatilityFutures_1 = require("./volatilityFutures");
__exportStar(require("./types"), exports);
__exportStar(require("./marketShift"), exports);
__exportStar(require("./vegaShock"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./extendedTableShock"), exports);
__exportStar(require("./pmParams"), exports);
__exportStar(require("./liquidityShock"), exports);
const sumComponents = (minNormalMarketShiftTable, extendedTableShock, normalTableOutlook, extendedTableOutlook, vega, liqShock) => {
    return normalTableOutlook === extendedTableOutlook
        ? Math.abs(minNormalMarketShiftTable) + extendedTableShock + vega + liqShock
        : Math.max(Math.abs(minNormalMarketShiftTable), extendedTableShock) +
            vega +
            liqShock;
};
const calculatePM = (positions, tickers, pmParams, calculationTimestamp) => {
    const positionsUuidMap = (0, utils_1.getPositionsUuidMap)(positions);
    const volFuturesTable = (0, volatilityFutures_1.calculateVolatilityFuturesTable)(positions, tickers, pmParams, calculationTimestamp);
    const marketShiftTables = (0, marketShift_1.calculateMarketShiftTables)(positions, positionsUuidMap, tickers, pmParams, volFuturesTable.table, calculationTimestamp);
    const vegaShock = (0, vegaShock_1.calculateVegaShock)(positions, tickers, pmParams, calculationTimestamp);
    const posGreeksMap = (0, utils_2.positionsGreeksMap)(positions, tickers, calculationTimestamp);
    const liqShock = (0, liquidityShock_1.calculateLiquidityShock)(positions, posGreeksMap, tickers, pmParams, calculationTimestamp);
    const extendedTableShock = (0, extendedTableShock_1.calculateExtendedTableShock)(marketShiftTables.marketShiftTableExtended, marketShiftTables.marketShiftInfo, pmParams, positionsUuidMap);
    const totalMM = sumComponents(marketShiftTables.marketShiftInfo.totalSumMin, extendedTableShock.shock, extendedTableShock.normalTableMarketShiftOutlook, extendedTableShock.extendedTableMarketShiftOutlook, vegaShock.totalVega, liqShock.liqTable.usdMarginTotal);
    const totalIM = totalMM * pmParams.general.initialMarginFactor;
    return {
        totalMM,
        totalIM,
        liqShock,
        vegaShock,
        marketShiftTables,
        extendedTableShock,
        pmParams,
        volFuturesTable,
    };
};
exports.calculatePM = calculatePM;
